import React, { Suspense } from 'react'
import { ModalBody, ModalHeader, Progress } from 'reactstrap'
import Modal from 'src/components/theme/Models/Modal'
import Body from './Body'

interface indexProps {
  id: string | undefined
  isOpen: boolean
  toggle: () => void
}

const index: React.FC<indexProps> = (props) => {
  const { id, isOpen, toggle } = props
  if (id === undefined) {
    return null
  }
  return (
    <Modal
      title='EEOC Paperwork'
      isOpen={isOpen}
      toggle={() => toggle()}
      size='xl'
    >
      <ModalHeader toggle={() => toggle()}>EEOC Paperwork</ModalHeader>
      <Suspense fallback={<ModalBody><Progress animated>Loading...</Progress></ModalBody>}>
        <Body id={id} />
      </Suspense>
    </Modal>
  )
}

export default index
